// src/services/api.js
import axios from 'axios';

const EUREKA_PACS_URL = process.env.REACT_APP_EUREKA_PACS_URL;

const API_URL = EUREKA_PACS_URL+'/token/generate-token';

export const getToken = async (username, password) => {
  try {
    console.log(API_URL);
    const response = await axios.post(API_URL, {
      login: username,
      password: password
    });
    return response.data.token;  // Retourne le token
  } catch (error) {
    console.error('Erreur lors de la connexion', error);
    return null;
  }
};
